module.exports = __webpack_public_path__ + "img/IMG_7264.3c0b33c6.jpg";